import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import WhatIfEmployeeRowPres from '../presentational/WhatIfEmployeeRowPres';
import { setEmployeeValue } from '../state/whatIfActions';

class WhatIfEmployeeRowContainer extends React.Component {
  static propTypes = {
    enqueueSnackbar: PropTypes.func.isRequired,
  };

  state = {
    keys: ['homeCountry', 'hostCountry', 'level', 'maritalStatus', 'noOfEmployees', 'startDate', 'endDate'],
    currencySet: ['USD'],
    outputCurrency: { value: 'USD', label: 'USD' },
    openDialog: false,
    params: [],
    showSelectionButtons: false,
  };

  componentDidMount() {}

  onChange = (id, target) => {
    const { employees, countriesDictionary } = this.props;
    const employee = employees[id];
    let homeCountry = employee.homeCountry;
    let employeeLevel = employee.level;

    if (target.name === 'homeCountry' || target.name === 'level') {
      // Reset host country to null on change of home country
      if (target.name === 'homeCountry') {
        this.props.setEmployeeValue(id, 'hostCountry', null);
        homeCountry = target.value;
      }

      if (target.name === 'level') {
        employeeLevel = target.value;
      }

      // Default salary
      if (homeCountry && employeeLevel) {
        this.props.setEmployeeValue(id, 'salary', countriesDictionary[homeCountry].salaries[employeeLevel]);
      }
    }
    this.props.setEmployeeValue(id, target.name, target.value);
  };

  render() {
    return <WhatIfEmployeeRowPres {...this.props} {...this.state} onChange={this.onChange} />;
  }
}

const mapStateToProps = state => ({
  employees: state.whatIf.employees,
  lookups: state.whatIf.lookups,
  results: state.whatIf.results,
  isLoading: state.whatIf.isLoadingCalculations,
  countriesDictionary: state.whatIf.countriesDictionary,
});

const mapDispatchToProps = {
  setEmployeeValue,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(WhatIfEmployeeRowContainer));
